// src/index.ts
import { loadStripe as _loadStripe } from "@stripe/stripe-js";
import pRetry from "p-retry";
var loadStripe = (publishableKey, options) => pRetry(() => _loadStripe(publishableKey, options), options);
export {
  loadStripe
};
